import type { ReactNode } from 'react'
import LineBedIcon from 'LuxKit/Icons/line/LineBedIcon'
import LinePlaneIcon from 'LuxKit/Icons/line/LinePlaneIcon'
import LineTicketIcon from 'LuxKit/Icons/line/LineTicketIcon'
import type { OrderTileData } from './bookingSelectionUtils'

const ORDER_TYPE_ICONS: Record<OrderTileData['primaryType'], ReactNode> = {
  hotel: <LineBedIcon size="M" colour="light-foreground-alt" />,
  flight: <LinePlaneIcon size="M" colour="light-foreground-alt" />,
  experience: <LineTicketIcon size="M" colour="light-foreground-alt" />,
}

export function getOrderTypeIcon(type: OrderTileData['primaryType']): ReactNode {
  return ORDER_TYPE_ICONS[type]
}
